import React from 'react'
import { isArray } from 'lodash-es'

export default ({ width, path, color, className, style }) => {
  return (
    <svg
      t="1633763667820"
      className={`${className} icon hidden md:block`}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      // p-id="2793"
      width={width}
      height={width}
      fill={color || 'currentColor'}
      style={style}
    >
      {isArray(path) ? (
        <>
          {path.map((v) => {
            return <path d={v} key={v} />
          })}
        </>
      ) : (
        <path d={path} />
      )}
    </svg>
  )
}
